<template>
  <div class="absolute w-full h-full top-0 left-0 bg-black-transparent flex items-center">
    <div id="edit_user_popup"
         class="popup p-4 mx-auto bg-white flex flex-col items-center classen__rounded relative"
         :class="{'with_permissions':(canChoosePermissions()),
                    'without_permissions':(!canChoosePermissions())}">
      <button class="self-end pr-5" @click="$emit('cancel')"><i class="fas fa-times text-3xl"></i>
      </button>
      <p class="text-2xl font-bold mb-2">{{ getTranslation('editUser') }}</p>
      <div class="w-full px-20">
        <div class="items-center grid-rows-5 text-left "
             :class="{'grid-rows-4':(!canChooseRegions()), 'grid-rows-5':(canChooseRegions())}">

          <div class="flex w-full">
            <p class="mandatory w-1/5">{{ getTranslation('name') }}:</p>
            <input v-model="selectedUser.name" type="text"
                   class="bg-gray py-1.5 pl-5 m-2 w-full col-span-5">
          </div>

          <div class="flex">
            <p class="mandatory w-1/5">{{ getTranslation('email') }}:</p>
            <input v-model="selectedUser.email" type="text"
                   class="bg-gray py-1.5 pl-5 m-2 w-full col-span-5">
          </div>
          <div class="flex">
            <p class="mandatory w-1/5">{{ getTranslation('language') }}:</p>
            <c-option-dropdown v-model="userLanguage" :options="languages"
                               :selected-option.sync="userLanguage"
                               class="m-2 w-full col-span-5"/>
          </div>
          <div class="flex">
            <p class="mandatory w-1/5">{{ getTranslation('role') }}:</p>
            <c-option-dropdown v-model="userRole" :options="roles" :selected-option.sync="userRole"
                               class="m-2 w-full col-span-5"/>
          </div>
          <div class="flex">
            <p v-if="canChoosePermissions()" class="mandatory w-1/5">
              {{ getTranslation('basedOnRole') }}:</p>
            <c-option-dropdown v-if="canChoosePermissions()" v-model="basedOnRole"
                               :options="basedOnRoles"
                               :selected-option.sync="basedOnRole" class="m-2 w-full col-span-5"/>
          </div>
          <div class="flex">
            <p v-if="canChooseRegions()" class="w-1/5"
               :class="{'mandatory ':(!canChoosePermissions())}">
              {{ getTranslation('region') }}:</p>
            <c-region-dropdown v-if="canChooseRegions()"
                               :selectedRegions.sync="selectedUser.regions"
                               :canCreateNewRegion="canCreateNewRegion()"
                               class="m-2 w-full col-span-5"/>
          </div>
        </div>

        <div v-if="canChoosePermissions() && this.selectedUser.permissions.basedOnRole.value !== ''"
             id="permissions"
             class="grid grid-cols-6 gap-1 items-center text-left overflow-auto h-1/4">
          <p class="self-start mt-3 mandatory">{{ getTranslation('permissions') }}:</p>
          <div class="mt-4 col-span-5 ml-2">
            <div v-for="permission in this.selectedUser.permissions.permissions"
                 class="grid justify-items-start">
              <div :id="permission.value">
                <div class="flex" @click="selectPermission(permission)">
                  <c-checkbox
                    :selected="permission.selected || subPermissionIsSelected(permission)"
                    :mode="'medium'"/>
                  <label>{{ permission.name }}</label>
                </div>
                <div class="grid ml-14">
                  <div v-for="subPermission in permission.permissions"
                       @click="subPermission.selected=!subPermission.selected" class="flex mr-12">
                    <c-checkbox :selected="subPermission.selected" :mode="'medium'"/>
                    <label>{{ subPermission.name }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <p v-if="warning!==null" class="text-red-500 pt-1">{{ warning }}</p>
      <button class="classen__button hover__button addButtonSendInvite mb-5 px-3"
              @click="editUser()">
        <p class="leading-none">{{ getTranslation('saveChanges') }}</p>
      </button>
    </div>
  </div>
</template>

<script>
import OptionDropdown from "../components/structure/OptionDropdown";
import AddUsersRegionDropdown from "../components/structure/Users/AddUsersRegionDropdown";
import CustomCheckbox from "../components/form/CustomCheckbox";
import getTranslation from "../mixins/getTranslation";
import getPermissions from "../mixins/getPermissions";

export default {
  name: "EditUserPopup",

  components: {
    'c-option-dropdown': OptionDropdown,
    'c-region-dropdown': AddUsersRegionDropdown,
    'c-checkbox': CustomCheckbox,
  },

  mixins: [getTranslation, getPermissions],

  props: {
    user: {required: true, type: Object}
  },

  data() {
    return {
      basedOnRole: {value: '', name: 'Choose a role...'},
      warning: null,
      selectedUser: JSON.parse(JSON.stringify(this.user)),
    }
  },

  created() {
    if (this.selectedUser.permissions.basedOnRole) {
      this.basedOnRole = this.basedOnRoles.find((x) => x.value === this.selectedUser.permissions.basedOnRole);
      return;
    }

    this.basedOnRole = {value: '', name: this.getTranslation('chooseRole')};
  },

  destroyed() {

  },

  watch: {
    basedOnRole() {
      this.selectedUser.permissions.basedOnRole = this.basedOnRole.value;
      this.setPermissionsForBasedOnRole();
    }
  },

  computed: {
    languages() {
      return this.$dashboardStore.getters.getLanguages;
    },

    regions() {
      return this.$dashboardStore.getters.getRegions;
    },

    roles() {
      return this.getRolesToAddUser();
    },

    basedOnRoles() {
      return this.getBasedOnRoles();
    },

    userEmailExists() {
      let users = this.$dashboardStore.getters.getUsers;

      return users.some((user) => user.email === this.selectedUser.email && user.id !== this.selectedUser.id);
    },

    userLanguage: {
      get() {
        return this.languages.find((x) => x.id === this.selectedUser.languageId);
      },
      set(language) {
        if (language.value === '') {
          return;
        }

        this.selectedUser.languageId = language.id
      }
    },

    userRole: {
      get() {
        return this.roles.find((x) => x.value === this.selectedUser.permissions.role);
      },
      set(role) {
        if (role.value === '') {
          return;
        }

        this.selectedUser.permissions.role = role.value
      }
    },

    userBasedOnRole: {
      get() {
        if (!this.selectedUser.permissions.basedOnRole) {
          return '';
        }

        let role = this.basedOnRoles.find((x) => x.value === this.selectedUser.permissions.basedOnRole);

        if (role !== undefined) {
          return role;
        }

        return '';
      },
      set(basedOnRole) {
        if (basedOnRole.value === '') {
          return;
        }

        this.selectedUser.permissions.basedOnRole = basedOnRole.value
      }
    },
  },

  methods: {
    editUser() {
      this.warning = this.getWarning();

      if (this.warning !== null) {
        return;
      }

      this.$dashboardStore.dispatch('updateUser', {
        userId: this.selectedUser.id,
        userData: {
          id: this.selectedUser.id,
          name: this.selectedUser.name,
          email: this.selectedUser.email,
          languageId: this.selectedUser.languageId,
          permissions: this.getUserPermissions(),
          isActive: this.selectedUser.isActive,
          regions: this.selectedUser.regions.map((x) => x.id)
        }
      })
        .then(() => {
          this.$dashboardStore.dispatch('reloadUsers')
            .then(() => {
              this.$emit('cancel');
            })
        })
        .catch((error) => {
          this.warning = "Something went wrong";
          console.warn('something went wrong saving user', error);
        });
    },

    setPermissionsForBasedOnRole() {
      if (this.basedOnRole.value === '') {
        return;
      }

      let permissions = this.getFlexiblePermissionsForAddUser();

      if (this.basedOnRoleHasSelectionPermission()) {
        this.deselectSelections(permissions);
      }

      if (this.basedOnRoleHasUsersPermission()) {
        this.deselectUsers(permissions);
      }

      if (this.basedOnRoleHasTranslationsPermission()) {
        if (this.basedOnRole === this.ROLES.REGIONAL_ADMIN) {
          this.deselectTranslationsForRegionalAdmin(permissions);
        }

        if (this.basedOnRole !== this.ROLES.REGIONAL_ADMIN) {
          this.deselectTranslations(permissions);
        }
      }

      if (this.basedOnRoleHasSharedLinkPermission()) {
        permissions.SELECTIONS.permissions.find((permission) => permission.value === 'permissionsSelectionsLink').selected = false;
      }

      this.selectedUser.permissions.permissions = permissions;
    },

    getWarning() {
      if (this.userEmailExists) {
        return this.getTranslation('emailExists');
      }

      if (
        this.selectedUser.name === null || this.selectedUser.email == null || this.userLanguage.value === "" || this.getUserPermissions().role === ""
        || (this.selectedUser.regions.length === 0 && this.canChooseRegions() && this.userRole.value !== this.ROLES.FLEXIBLE.value)
      ) {
        return this.getTranslation('emptyRequiredField');
      }

      return null;
    },

    getUserPermissions() {
      let userPermissions = {role: this.selectedUser.permissions.role}
      if (this.selectedUser.permissions.role === this.ROLES.FLEXIBLE.value) {
        userPermissions = {
          role: this.selectedUser.permissions.role,
          basedOnRole: this.selectedUser.permissions.basedOnRole,
          permissions: this.selectedUser.permissions.permissions
        };
      }
      return userPermissions;
    },

    selectPermission(permission) {
      if (permission.selected === true) {
        permission.selected = false;
        permission.permissions.forEach((subPermission) => {
          subPermission.selected = false
        });
      } else {
        permission.selected = true;
      }
    },

    subPermissionIsSelected(permission) {
      if (permission.permissions !== undefined) {
        if (permission.permissions.filter((subPermission) => subPermission.selected === true).length > 0) {
          permission.selected = true;
        }
      }
    },

    canChooseRegions() {
      return this.userRole.value === this.ROLES.REGIONAL_ADMIN.value || this.userRole.value === this.ROLES.SALES_ADMIN.value || this.userRole.value === this.ROLES.FLEXIBLE.value;
    },

    canCreateNewRegion() {
      return this.userRole.value === this.ROLES.REGIONAL_ADMIN.value;
    },

    canChoosePermissions() {
      return this.userRole.value === this.ROLES.FLEXIBLE.value;
    },

    getFlexiblePermissionsForAddUser() {
      return {
        ARTICLES: {value: "permissionsArticles", name: "Articles", selected: true},
        DECORS: {value: "permissionsDecors", name: "Decors", selected: true},
        PACKAGES: {value: "permissionsPackages", name: "Packages", selected: true},
        SELECTIONS: {
          value: "permissionsSelections",
          name: "Selections",
          selected: true,
          permissions: [
            {value: "permissionsSelectionsView", name: "view", selected: true},
            {value: "permissionsSelectionsEdit", name: "edit", selected: true},
            {value: "permissionsSelectionsAdd", name: "add", selected: true},
            {value: "permissionsSelectionsImages", name: "Request images", selected: true},
            {value: "permissionsSelectionsLink", name: "Generate shared link", selected: true},
            {value: "permissionsSelectionsExcel", name: "Generate excel", selected: true},
            {value: "permissionsSelectionsPdf", name: "Generate pdf", selected: true}
          ]
        },
        USERS: {
          value: "permissionsUsers",
          name: "Users",
          selected: true,
          permissions: [
            {value: "permissionsUsersView", name: "view", selected: true},
            {value: "permissionsUsersEdit", name: "edit", selected: true},
            {value: "permissionsUsersDeactivate", name: "deactivate", selected: true},
            {value: "permissionsUsersDelete", name: "delete", selected: true},
            {value: "permissionsUsersAdd", name: "add", selected: true}
          ]
        },
        TRANSLATIONS: {
          value: "permissionsTranslations",
          name: "Translations",
          selected: true,
          permissions: [
            {value: "permissionsTranslationsView", name: "view", selected: true},
            {value: "permissionsTranslationsEdit", name: "edit", selected: true},
            {value: "permissionsTranslationsDelete", name: "delete", selected: true},
            {value: "permissionsTranslationsAdd", name: "add", selected: true}
          ]
        },
        MARKETING: {value: "permissionsMarketing", name: "Marketing", selected: false}
      };
    },

    basedOnRoleHasSelectionPermission() {
      return this.basedOnRole === this.ROLES.PRODUCTION;
    },

    basedOnRoleHasSharedLinkPermission() {
      return this.basedOnRole === this.ROLES.REGIONAL_ADMIN || this.basedOnRole === this.ROLES.SALES_ADMIN;
    },

    basedOnRoleHasUsersPermission() {
      return this.basedOnRole === this.ROLES.PRODUCTION || this.basedOnRole === this.ROLES.SALES_ADMIN;
    },

    basedOnRoleHasTranslationsPermission() {
      return this.basedOnRole === this.ROLES.PRODUCTION || this.basedOnRole === this.ROLES.SALES_ADMIN || this.basedOnRole === this.ROLES.REGIONAL_ADMIN;
    },

    deselectSelections(permissions) {
      permissions.SELECTIONS.selected = false;
      permissions.SELECTIONS.permissions.forEach((permission) => {
        permission.selected = false;
        return permission;
      });
    },

    deselectUsers(permissions) {
      permissions.USERS.selected = false;
      permissions.USERS.permissions.forEach((permission) => {
        permission.selected = false;
        return permission;
      });
    },

    deselectTranslations(permissions) {
      permissions.TRANSLATIONS.selected = false;
      permissions.TRANSLATIONS.permissions.forEach((permission) => {
        permission.selected = false;
        return permission;
      });
    },

    deselectTranslationsForRegionalAdmin(permissions) {
      permissions.TRANSLATIONS.permissions.find((permission) => permission.value === 'permissionsTranslationsDelete').selected = false;
      permissions.TRANSLATIONS.permissions.find((permission) => permission.value === 'permissionsTranslationsAdd').selected = false;
    },
  }
}
</script>

<style scoped>
#edit_user_popup {
  width: 996px;
}

#permissions {
  height: 300px;
}

.without_permissions {
  height: 708px;
}

.with_permissions {
  height: 850px;
}

.mandatory::after {
  color: #E60000;
  content: "*";
}

.addButtonSendInvite {
  position: absolute;
  bottom: 0;
  width: auto;
}
</style>
